import { useState } from 'react';
import { useSelector } from 'react-redux';
import { User } from '../../../../../../shared/models/UserModels';
import DisableAccessModal from './DisableAccessModal';
import { useRemoveUserAccessBulkActionMutation } from './apiSlice';
import { accountSelector } from '../../../../../../shared/store/shared/accountSlice';
import { toastWithAnalytics } from '../../../../../../shared/analytics';
import useUser from '../../../../../../shared/hooks/useUser';

export default function DisableAccessAction({
  onActionComplete,
  selectedUsers,
}: {
  onActionComplete: () => void;
  selectedUsers: User[];
}) {
  const user = useUser();
  const { currentAccountId } = useSelector(accountSelector);
  const [removeUserAccess, removedUserAccess] =
    useRemoveUserAccessBulkActionMutation();
  const [showEditUsersModal, setShowEditUsersModal] = useState(true);
  const toRemoveUsers = selectedUsers.filter((u) => !u.isRemoved);
  if (showEditUsersModal) {
    return (
      <DisableAccessModal
        onCancel={() => {
          onActionComplete();
          setShowEditUsersModal(false);
        }}
        selectedUsers={toRemoveUsers}
        onSubmit={(e: Event | any) => {
          const accountIds: string[] = toRemoveUsers.map((user) =>
            user.id.toString(),
          );
          e.target.disabled = true;
          const removeUsers = accountIds.map((a) => ({
            modifiedByPersonId: `${user.person_id}`,
            userId: a,
          }));
          removeUserAccess({
            accountId: currentAccountId,
            removeUsers,
          })
            .unwrap()
            .then(() => {
              toastWithAnalytics(
                `${accountIds.length} user${accountIds.length > 1 ? 's' : ''} ${
                  accountIds.length > 1 ? 'have' : 'has'
                } been disabled.`,
                'success',
              );
              removedUserAccess.reset();
              onActionComplete();
            })
            .catch(() => {
              toastWithAnalytics(
                'Failed to disable users. Please try again.',
                'danger',
              );
              e.target.disabled = false;
              setShowEditUsersModal(false);
            });
        }}
      />
    );
  }
  return null;
}
